export const isInternalImpersonation = () => {
  const email = window.hijackedUser?.user.email;
  if (!email) {
    return false;
  }
  return (
    email.endsWith("@topicflow.com") ||
    email.endsWith("@gettopicflow.com") ||
    /@demoorg-\d+\.test$/.test(email)
  );
};
